import React ,{useState} from 'react';
import {AdminWalkthroughview} from './admin-walkthrough-view';
import './admin-walkthrough.scss';
export const AdminWalkthroughController =(props)=>{
    return(
             <AdminWalkthroughview {...props}/>
    )
}